<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <button class="navbar-toggler" type="button" @click="toggleSidebar">
      <span class="navbar-toggler-icon" />
    </button>

    <router-link
      :to="{name: 'statistics'}"
      class="navbar-brand mr-auto ml-2 d-flex align-items-center"
    >
      <p class="text-center ml-1 mb-0 mb-0 text-white active">Al-Shayah</p>
    </router-link>

    <ul class="navbar-nav">
      <li class="nav-item active">
        <a class="nav-link" href="javascript:undefined" @click="logout">Logout</a>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapState } from "vuex";

export default {
  methods: {
    toggleSidebar() {
      if (this.$store.state.sidebarOpen) this.$store.dispatch("closeSidebar");
      else this.$store.dispatch("openSidebar");
    },

    logout() {
      this.$store.dispatch("auth/logout");
      this.$router.push({ name: "login" });
    },
  },

  computed: {
    ...mapState({
      notifications_count: (state) => state.notifications.count,
    }),
  },
};
</script>

<style scoped>
</style>

